// Instarent plugin

/**
 * @author -- Peter Collins cpnzereogu@gmail
 */

import globalClasses from '../classes/.globalClasses'
import globalComponents from '../components/.globalComponents'
import globalMixin from '../mixins/.globalMixins'
import globalStyles from '../layout/.globalStyles'

export default {
/* eslint-disable-next-line */
  install(Vue,options) {
    Vue.use(globalClasses)
    Vue.use(globalComponents)
    Vue.use(globalMixin)
    Vue.use(globalStyles)
  }
}